const tabSchema = {
	group: "block",
	content: "block+",
	defining: true,
	attrs: {
		name: { default: null },
		icon: { default: null },
		tag: { default: null },
		idx: { default: null },
	},
};

export default tabSchema;
